import { verifySignature, z } from './deps.js';
/** Schema to validate Nostr hex IDs such as event IDs and pubkeys. */
const nostrIdSchema = z.string().regex(/^[0-9a-f]{64}$/);
/** Nostr kinds are positive integers. */
const kindSchema = z.number().int().nonnegative();
/** Parses a JSON string. */
const jsonSchema = z.string().transform((value, ctx) => {
    try {
        return JSON.parse(value);
    }
    catch (_e) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Invalid JSON' });
        return z.NEVER;
    }
});
/** Nostr event template schema. */
const eventTemplateSchema = z.object({
    kind: kindSchema,
    tags: z.array(z.array(z.string())),
    content: z.string(),
    created_at: z.number(),
});
/** Nostr event schema. */
const eventSchema = eventTemplateSchema.extend({
    id: nostrIdSchema,
    pubkey: nostrIdSchema,
    sig: z.string(),
});
/** Nostr event schema that also verifies the event's signature. */
const signedEventSchema = eventSchema.refine(verifySignature);
/** NIP-46 signer request. */
const connectRequestSchema = z.object({
    id: z.string(),
    method: z.literal('sign_event'),
    params: z.tuple([eventTemplateSchema]),
});
const relayEventSchema = z.tuple([z.literal('EVENT'), z.string(), signedEventSchema]);
const relayOkSchema = z.tuple([z.literal('OK'), nostrIdSchema, z.boolean(), z.string()]);
const relayEoseSchema = z.tuple([z.literal('EOSE'), z.string()]);
const relayNoticeSchema = z.tuple([z.literal('NOTICE'), z.string()]);
const relayUnknownSchema = z.tuple([z.string()]).rest(z.unknown());
/** Relay message to a Nostr client. */
const relayMsgSchema = z.union([
    relayEventSchema,
    relayOkSchema,
    relayEoseSchema,
    relayNoticeSchema,
]);
export { connectRequestSchema, eventSchema, jsonSchema, kindSchema, nostrIdSchema, relayMsgSchema, relayOkSchema, relayUnknownSchema, signedEventSchema, };
